<template>
    <div id="content">
        <sweet-modal ref="modal" title="Lien Wetransfer">
            <form>
                <input type="hidden" name="operationId" id="operationId" v-model="form.operationId" >
                <label for="wetransferURL">wetransfert URL *</label>
                <input  type="text"
                         :disabled="editmode"
                        id="wetransferURL"
                        name="wetransferURL"
                        v-validate="{url: {require_protocol: true, required :true }}"
                        v-model="form.wetransferURL"
                        placeholder="https://"
                        required>
                <div class="error">{{ errors.first('wetransferURL') }}</div>
                <br />
                <div v-if="editmode">
                <label for="url">URL</label>
                <input  type="text"
                        id="url"
                        :disabled="editmode"
                        v-validate="{url: {require_protocol: true }}"
                        name="url"
                        v-model="form.url"
                        placeholder="https://">
                <div class="error">{{ errors.first('url') }}</div>
                <br />
                </div>
                         <div class="elem">
                            <label for="role">Projet</label>
                            <multiselect style="width:87%;" v-model="form.projet"
                                         :options="typeList"
                                         id="projet"
                                         name="projet"
                                         placeholder="Assigner à"
                                         select-label="Cliquez pour ajouter"
                                         deselect-label="Cliquez pour supprimer"
                                         label="title"
                                         track-by="_id">
                            </multiselect>
                            <div class="error">{{ errors.first('roles') }}</div>
                        </div>
                <br />
                <label  for="description">Description *</label>
                <input  type="text"
                        id="description"
                        name="description"
                        v-validate="'required'"
                        v-model.lazy="form.description"
                        placeholder="Description courte">
                <div class="error">{{ errors.first('description') }}</div>
                <br />
                <span class="obl">*Champs obligatoires</span>
                <br />
                <div class="form-end">
                    <button class="btn-red" type="button"
                            @click.prevent="closeModal()"> Annuler</button>&nbsp;
                    <button v-if="!editmode" class="btn-blue" type="submit"
                            @click.prevent="submited()"><i class="fa fa-save"></i> Sauvegarder</button>
                    <button v-if="editmode" class="btn-blue" type="submit"
                            @click.prevent="modified()"><i class="fa fa-save"></i> Modifier</button>
                </div>
            </form>
        </sweet-modal>
        <div class="contenair homeop">
            <h1><i class="fa fa-cloud-download" aria-hidden="true"></i> Contenu Wetransfer</h1>
            <div class="add-op">
                <button class="btn-blue" v-on:click="openModal()"><i class="fa fa-plus"></i> Nouveau Document</button>
            </div>
            <br />
            <div class="research">
               <VueFuse placeholder="Recherchez un document" :list="links" event-name="results" :keys="['description', 'wetransferURL', 'title', 'operationId']" />
            </div>
            <br />
            <h3>{{ totalLinks }} Document(s)</h3>

            <br />
            <div>
                <div class="bloc-user" v-for="(item, index) in results" :key="index">
                      <div class="userlist">
                          <div style="width: 90%">
                                <span class="badge badge-projetname" v-if="item.title">
                                    {{ item.title }}
                                </span>
                                {{item.description}} ( {{item.wetransferShortURL || 'uploading'}} <span v-if="item.expiresAt"> - exp: {{$moment(item.expiresAt).format('DD/mm/YYYY')}}</span> ) <a :href="prefixUrl(item.url)" v-if="item.url" target="_blank"><i class="fa fa-download"></i></a>
                          </div>
                          <div>
                            <i class="fa fa-trash-o" v-on:click="deleteDoc(item._id)"></i>
                            &nbsp;|&nbsp;
                            <i v-on:click="modifDoc(item._id)" class="fa fa-pencil-square-o" aria-hidden="true"></i>
                          </div>
                      </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { SweetModal, SweetModalTab, } from 'sweet-modal-vue'
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import VueFuse from 'vue-fuse'

Vue.use(VueFuse)

    export default {
        name: 'wetransfer',
        components: {
            SweetModal,
            SweetModalTab,
            Multiselect
        },
        created () {
                this.$on('results', results => {
                this.results = results
                })
         },
         computed: {
            filtered () {
                var filtered = this.links
                return filtered
            }
        },
    data: function () {
            return {
                edit_id : undefined,
                editmode : false,
                links:[],
                results:[],
                typeList: [],
                totalLinks : 0,
                form: {
                    url: undefined,
                    wetransferURL: undefined,
                    description : undefined,
                    operationId : undefined,
                    title : undefined,
                    projet : undefined,
                }
            }
        },
        mounted() {
            this.load();
        },
        methods: {
           async modified() {
                this.$validator.validateAll().then(async(valid) => {
                    if(valid) {

                        console.log(this.form)
                        if(this.form.projet) { 
                           this.form.operationId = this.form.projet._id  
                        }

                        try {
                           let result = await this.$axios.put('/api/wetransfer/update/'+this.edit_id, {
                                ...this.form
                            });

                            if(result.data) {
                               this.closeModal()
                               this.load()
                            }
                        }
                        catch(error) {
                            console.log(error);
                        }
                    }
                });
           },
           async submited() {            
                this.$validator.validateAll().then(async(valid) => {
        
                    if(valid) {
                        
                        try {
                            if(this.form.projet) { 
                                this.form.operationId = this.form.projet._id  
                            }  
                            console.log()
                           let result = await this.$axios.post('/api/wetransfer/save', {
                                ...this.form
                            });

                            if(result.data) {
                               this.closeModal()
                               this.load()
                            }
                        }
                        catch(error) {
                            console.log(error);
                        }
                    }
                });
            },
            async load() {

                let projects = await this.$axios.get('/api/operations/list/nofinish');
                this.typeList = projects.data

                let newlist = []
                let links = await this.$axios.get('/api/wetransfer/list/');

                links.data.forEach(async (item) => {
                    if(item.operationId) {
                        let name = await this.$axios.get('/api/operations/getname/' + item.operationId)
                         if(name) item.title = name.data.title
                         if(name) item.projet = [ name.data.title, item.operationId ]
                    }
                    newlist.push(item);
                });
                this.links = newlist
 
                let count = await this.$axios.get('/api/wetransfer/count/')
                this.totalLinks = count.data.status
            },
            async modifDoc(_id) {
                this.edit_id = _id   
                this.editmode = true
                let data =  await this.$axios.get('/api/wetransfer/'+_id)
                this.form = data.data
               if(this.form.operationId) {
                    let name = await this.$axios.get('/api/operations/getname/' + this.form.operationId)
                    if(name) this.form.projet = [ name.data.title, this.form.operationId ]
                }        
                this.$refs.modal.open();
                return;
            },
            closeModal() {
                this.editmode = false
                this.$refs.modal.close();
                return;
            },
            openModal() {
                this.form = []
                this.editmode = false
                this.$refs.modal.open();
                return;
            },
            deleteDoc(id) {

                this.$swal({
                title: '&Ecirc;tes vous sur ?',
                text: "Supprimer ce document ?",
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Annuler',
                confirmButtonText: 'Oui, je le supprime !'

                }).then((result) => {
                if (result.value) {

                    this.$axios.get('/api/wetransfer/delete/'+id).then((response) => {

                        this.$swal(
                            'Supprimé !',
                            'Le document à bien été supprimé.',
                            'success'
                            )
                        this.load();

                    }).catch((error) => {
                        console.log(error);
                    })
                }
                })
            },
            prefixUrl(url) {
                if (String(url).match(/^https?:\/\//)) return url;
                return `https://${url}`;
            },
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>